import { AxiosResponse } from 'axios';
import { Api } from 'api/api';
import { Endpoints } from 'modules/core/constants';

class PassengerCapacitiesApi extends Api {
  getPassengerCapacities = (): Promise<AxiosResponse<number[]>> => this.api.get(Endpoints.getPassengerCapacities);
}

export default new PassengerCapacitiesApi();
